import { useCallback, useMemo } from 'react';

import { SuccessProps } from './success.types';
import { useModalsContext } from '../../../../../../contexts';
import { useTranslation } from 'react-i18next';

/**
 * useSuccessData hook
 * @description The hook which processes CloseAllPositions flow Success data
 *
 * @author Oleksii Medvediev
 * @category Hooks
 */
const useSuccessData = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'management' });
  const {
    data: { paymentSettingsSuccess },
  } = useModalsContext();

  const flowData: SuccessProps | undefined = useMemo(() => paymentSettingsSuccess, [paymentSettingsSuccess]);

  const handleSubmitSuccess = useCallback(() => {
    flowData && flowData.onSubmitSuccess();
  }, [flowData]);

  return {
    t,
    handleSubmitSuccess,
  };
};

export { useSuccessData };
